module.exports = __webpack_public_path__ + "static/hero-09-b928fd12f8dd8ed403443bf9868f0a55.jpg";